import { Stack } from "@mui/material";
import { HubSpotIcon, MarketoIcon, SalesForceIcon } from "../../../../images";
import { useEffect, useState } from "react";
import { SyncCRMModal } from "../../../../ui/modal/SyncCRMModal/SyncCRMModal";
import { useLazyGetCRMListQuery } from "../../../../../api";
import {
  CRMData,
  CRMListItem,
  IntegrationType,
} from "../../../../../types/apiTypes";
import { toast } from "react-toastify";
import { CustomToast } from "../../../../ui/CustomToast";
import { getErrorMessage } from "../../../../../utils/getErrorMessage";
import { useGetCRMUrlMutation } from "../../../../../api";
import { useNavigate } from "react-router-dom";
import { AppRoutes, Integration } from "../../../../../types/enums";
import { LoginMarketoModal } from "../../../../ui/modal";
import { Method } from "./Method";

export type UploadMethod = IntegrationType | "";

export const CRMUploadMethod = ({
  setDataSource,
  isDisabled,
  currentCrm,
}: {
  setDataSource: (data: CRMData) => void;
  isDisabled: boolean;
  currentCrm: UploadMethod;
}) => {
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState<UploadMethod>("");
  const [crm, setCrm] = useState<UploadMethod>("");
  const [uploadMethod, setUploadMethod] = useState<UploadMethod>(currentCrm);
  const [crmList, setCrmList] = useState<CRMListItem[]>([]);

  const [getCRMUrl] = useGetCRMUrlMutation();
  const [getCRMListQuery, { isFetching }] = useLazyGetCRMListQuery();

  useEffect(() => {
    setUploadMethod(currentCrm);
  }, [currentCrm]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const crm = urlParams.get("crm");
    if (crm) {
      setCrm(crm as UploadMethod);
      navigate(AppRoutes.CREATE_CAMPAIGN, {
        replace: true,
      });
    }
  }, []);

  useEffect(() => {
    if (crm && crm !== Integration.marketo) {
      getCRMListQuery(crm)
        .unwrap()
        .then((data) => {
          setCrmList(data || []);
          setOpenModal(crm);
          setCrm("");
        })
        .catch(async (err) => {
          if (err?.status === 428) {
            getCRMUrl({
              campaign_id: "",
              action_type: "create",
              redirect_path: location.pathname,
              crm: crm,
            })
              .unwrap()
              .then((data) => {
                window.location.href = data.url;
              })
              .catch((err) =>
                toast.error(
                  <CustomToast
                    type="error"
                    text={
                      getErrorMessage(err).globalError ||
                      "Something went wrong. Please try again"
                    }
                    title="Connection Failed."
                  />,
                ),
              );
          } else {
            toast.error(
              <CustomToast
                type="error"
                text={
                  getErrorMessage(err).globalError ||
                  "The company data upload failed."
                }
                title="Upload Failed"
              />,
            );
          }
        });
    }
    if (crm === Integration.marketo) setOpenModal(crm);
  }, [crm]);

  const setDataSourceHandler = (data: CRMData) => {
    setDataSource(data);
    setUploadMethod(data.crm);
  };

  return (
    <Stack gap="8px">
      <Stack flexDirection="row" gap="8px">
        <Method
          isLoading={crm === Integration.hubspot}
          icon={<HubSpotIcon />}
          title="HubSpot"
          btnHandler={() => setCrm(Integration.hubspot)}
          text="Automatically import all your contacts and accounts directly from HubSpot CRM into the platform."
          isSynced={uploadMethod === Integration.hubspot}
          isDisabled={!!uploadMethod || isDisabled}
        />
        <Method
          isLoading={crm === Integration.salesforce}
          icon={<SalesForceIcon />}
          title="Salesforce"
          btnHandler={() => setCrm(Integration.salesforce)}
          text="Quickly bring your Salesforce CRM contacts and accounts into the system to start working right away."
          isSynced={uploadMethod === Integration.salesforce}
          isDisabled={!!uploadMethod || isDisabled}
        />
        {openModal &&
          (openModal === Integration.marketo ? (
            <LoginMarketoModal
              onClose={() => setOpenModal("")}
              syncModal={(list) => (
                <SyncCRMModal
                  crmList={list}
                  openModal={openModal}
                  onClose={() => setOpenModal("")}
                  setDataSource={setDataSourceHandler}
                  setOpenModal={setCrm}
                  isLoading={isFetching}
                />
              )}
            />
          ) : (
            <SyncCRMModal
              crmList={crmList}
              openModal={openModal}
              onClose={() => setOpenModal("")}
              setDataSource={setDataSourceHandler}
              setOpenModal={setCrm}
              isLoading={isFetching}
            />
          ))}
      </Stack>
      {/*<Stack flexDirection="row" gap="8px" maxWidth={"calc(50% - 4px)"}>*/}
      {/*  <Method*/}
      {/*    isLoading={false}*/}
      {/*    icon={<MarketoIcon />}*/}
      {/*    title="Marketo"*/}
      {/*    btnHandler={() => setOpenModal(Integration.marketo)}*/}
      {/*    text="Sync contact, account and engagement from Marketo into the platform*/}
      {/*     to keep your marketing data up to date."*/}
      {/*    isSynced={uploadMethod === Integration.marketo}*/}
      {/*    isDisabled={!!uploadMethod || isDisabled}*/}
      {/*  />*/}
      {/*</Stack>*/}
    </Stack>
  );
};
